<template>
  <BoardView :title="sectionTemplate.name">
    <FormValidation @submit="save">
      <FormSectionTemplate :sectionTemplate="sectionTemplate" />
      <Btn class="info" :isLoading="isSaving" type="submit">
        {{ $t('submit') }}
      </Btn>
    </FormValidation>
  </BoardView>
</template>

<script>
import BoardSingle from '@mixins/BoardSingle'
import FormSectionTemplate from '@forms/FormSectionTemplate'
import { actions } from '@utils'

export default {
  mixins: [BoardSingle('sectionTemplate')],
  components: { FormSectionTemplate },
  methods: actions(
    'FETCH_PROMPT',
  ),
  created() {
    this.FETCH_PROMPT()
  },
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "submit": "Update"
  }
}
</i18n>
